<script setup lang="ts"></script>

<template>
  <div
    v-for="n in 18"
    :key="n"
    class="mb-[1px] h-[240px] animate-pulse rounded-xl bg-skin-border md:mb-0"
  />
</template>
